<template>
	<section :class="['header-simple', { 'header-simple--space-top': spaceTop }]">
		<div class="header-simple__content">
			<h1 class="header-simple__h1">{{ title }}</h1>
			<h2 class="header-simple__h2">{{ subtitle }}</h2>
		</div>
		<div class="header-simple__options">
			<slot></slot>
		</div>
	</section>
</template>

<script>
export default {
	name: 'header-simple',
	props: {
		title: {
			type: String,
			default: 'IDICARE'
		},
		subtitle: {
			type: String,
			default: 'We care about your well-being. Leading Innovation in Health Aid Tecnhologies.'
		},
		spaceTop: {
			type: Boolean,
			default: true
		}
	}
}
</script>

<style scoped>
.header-simple {
	display: flex;
	padding: 0 0 20px 0;
}
.header-simple.header-simple--space-top {
	padding-top: 50px;
}
.header-simple__content {
	flex: 1;
}
.header-simple__h1 {
	color: var(--main-color);
	font-size: 24px;
	font-weight: 900;
	border: 0;
	padding: 0;
	margin: 0;
}
.header-simple__h2 {
	color: #aaa;
	font-size: 12px;
	font-weight: 400;
	border: 0;
	padding: 0;
	margin: 5px 0 0 0;
}
.header-simple__options {
	display: flex;
	align-items: center;
}
@media screen and (max-width: 768px) {
	.header-simple {
		flex-direction: column;
	}
	.header-simple__content {
		margin-bottom: 20px;
	}
	.header-simple__options {
		justify-content: flex-end;
	}
	.header-simple__options > *:first-child {
		margin-left: 0;
		flex: 1;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/HeaderSimple.vue